import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutMovementRetrieve } from 'types';
import { client } from 'utils/api-client';

function useWorkoutBenchmark(
  benchmarkId: string | undefined,
): UseQueryResult<{ data: WorkoutMovementRetrieve }> {
  return useQuery(
    ['workoutBenchmarks', benchmarkId],
    () => client.get(`workout-movements/${benchmarkId}/`),
    {
      enabled: !!benchmarkId,
    },
  );
}

export default useWorkoutBenchmark;
